// extracted by extract-css-chunks-webpack-plugin
module.exports = {"intro":"intro_7WDfh","intro_item":"intro_item_FXtXJ","animated":"animated_4XO-s","introFadeIn":"introFadeIn_MflKG"};